require('../../modules/es6.typed.uint8-array');
module.exports = require('../../modules/_core').Uint8Array;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/typed/uint8-array.js
// module id = 5flq
// module chunks = 0